import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** 두 앱이 같은 병합 규칙을 쓰도록 프리미티브 안에서 해결한다. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
